export class MessageConstants {
    public static NO_DATA = 'No data found';
    public static SESSION_EXPIRE = 'Your session has been expired. Please Login again.';
}
